import React from "react";

function getChatEventActions(chat, emitEvent, formatMessage, processInstance) {
  if (!chat.elements?.length) {
    return null;
  }

  let chatEventsConfig =
    Object.values(window.Social.getChatEventsConfig()) || [];

  chatEventsConfig = chatEventsConfig.filter((event) => {
    const requiredElements = event.requiredElements;

    if (requiredElements.length === 0) {
      return event;
    }

    const chatElements = chat.elements.map((element) => element.description);

    return requiredElements.every((element) => chatElements.includes(element));
  });

  const eventActions = chatEventsConfig.map((event) => {
    const payload = { elements: chat.elements, processInstance };

    return (
      <span
        className="message-box-option"
        key={event.eventName}
        onClick={() => emitEvent(event.eventName, payload)}
      >
        {event.label ||
          formatMessage({ id: `chat.chatEvents.${event.eventName}` })}
      </span>
    );
  });

  if (eventActions && eventActions.length > 0) {
    eventActions.push(<span className="separator" key="item-separator"></span>);

    return eventActions;
  }

  return null;
}

export default getChatEventActions;
